//============================
//# csisyncdictionary
//# Interfész szinkron mappelés a felület választóihoz (külső kód + K2D megnevezés)
//============================

export default interface IfaceSyncDictionaryOption {
    /** Külső kód — ez kerül vissza a köztes táblába */
    extCode: string;
    /** K2D törzs azonosító */
    intCode: number;
    /** A K2D törzs rekord megnevezése */
    intName: string;
    /** A mappelés külső megnevezése, ha a szótárban meg van adva */
    extName: string;
}

/** Választó megjelenítése: "(külső kód) K2D megnevezés" — megnevezés nélkül csak a kód */
export function optionDisplay(option: IfaceSyncDictionaryOption): string {
    return option.intName ? `(${option.extCode}) ${option.intName}` : option.extCode;
}

export const IfaceSyncDictionaryOptionDefaultProps: IfaceSyncDictionaryOption = {
    extCode: "",
    intCode: 1,
    intName: "",
    extName: "",
}
